import type { CaseType } from '@/constants';
import type { IBroker } from './IBroker';
import type { IQuotationResponse } from './IQuotationResponse';
import type { IUser } from './IUser';

export enum CasePortability {
	PortoSeguro,

	QuintoCred,

	Credipago,

	Loft,

	Avalyst,

	Imovpago,

	FiancaRapida,

	Fiantec,

	SeuFiador,

	Pottencial,

	Garantti,

	TioGiba,
}

export interface ICaseParams {
	invoicedSetupBefore: boolean;
	portability: null | CasePortability;
	onePlusZeroPlusEleven: boolean;
	isProcessing: boolean;
	/**
	 * Esta renovação alterou os encargos do aluguel e vai reenviar o contrato para assinatura
	 * (ENG-587). Quem decide é o servidor, comparando com a cotação do ciclo anterior — o checkbox
	 * da tela é só o consentimento do parceiro.
	 *
	 * Opcional porque a resposta de caso que não é renovação pode não trazer o campo.
	 */
	renewalRequiresSignature?: boolean;
}

export interface ICase {
	contractStartedAt: string | null;
	contractFinishedAt: string | null;
	quotation: IQuotationResponse;
	contractId: null;
	quotationId: string;
	productId: string;
	brokerId: string;
	status: number;
	reviewCount: number;
	createdBy: IUser;
	broker: IBroker;
	//product:     IProduct;
	id: string;
	createdAt: string;
	updatedAt: string;
	deletedAt: null;
	createdById: string;
	deletedById: null;
	caseType: CaseType;
	/** Contrato ao qual o caso está vinculado (ocorrência, cobrança, renovação). */
	caseRelatedId?: string | null;
	MessagesCount: number;

	paymentUrl: string;
	signUrl: string;
	cancelledAt?: string;
	cancelledReason?: string;
	/** Motivo do override ao abrir a Recorrente sem o pacote do Locador (ENG-568, DEC-23). */
	lessorWaiverReason?: string | null;
	is: ICaseParams;

	/** Code do gestor responsável (ex.: 'INTERNAL', 'VOLTZ'). */
	managedBy: string;

	/** Nova / Recorrente / Final — só CASE_OCCURRENCE. */
	occurrenceType?: string | null;
}
